import { uxLiveSearch } from '../modules/ux/liveSearch.js';


// --- page main script ---				
var pageHospitalCenterScript = function(item) {

	this.item = item;

	
	if (!this.hasOwnProperty('item')) {
		
		return false;

	};


	this._init();

};


pageHospitalCenterScript.prototype = {

	_init: function() {

		if (this.item.querySelector('.hc-service') !== null) {

			this._variable();
			this._event();

		}

	},


	_variable: function() {

		// "Услуги, операции и цены"
		this.hsService = this.item.querySelector('.hc-service');
		this.hcServiceCategoryContainer = this.hsService.querySelector('.list-service-category');

	},


	_event: function() {

		// "Услуги, операции и цены"
		if (this.hsService.classList.contains('live-search__js') == true) {

			this.hcServiceCategoryContainer.addEventListener('change', this._event_change_hcService.bind(this), false);
		
		}
	
	},


	// "Услуги, операции и цены": повторно инициализируем live-search, когда меняется или дополняется список услуг 
	_event_change_hcService: function() {
		
		let uxLiveSearchInitService = new uxLiveSearch(this.hsService);

	}

};
// --- /page main script ---



// init
document.addEventListener('DOMContentLoaded', function() {

	var pageHospitalCenterElement = document.querySelector('.hc');


	if (pageHospitalCenterElement !== null) {
		
		let pageHospitalCenterScriptInit = new pageHospitalCenterScript(pageHospitalCenterElement);

	}

});